import { InputAdornment, TextField } from '@mui/material';

const PercentageField = props => <TextField
  InputProps={{
    endAdornment: <InputAdornment position="end">%</InputAdornment>
  }}
  {...props} />

export default PercentageField;
